import { type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from 'antd';
import { createFormFields } from 'pos-client/components/shared/Form/FormUtils.ts';
import { PosInputNumber } from 'pos-client/components/shared/Form/PosInputNumber.tsx';
import { PosSelect } from 'pos-client/components/shared/Form/PosSelect.tsx';
import { useServiceJobTypes } from 'pos-client/hooks/useServiceJobTypes.ts';
import { sortStrings } from 'pos-client/utils/dataTableHelpers.tsx';
import type { RouteModel } from 'pos-shared/models/resourceManagementSchema.ts';
import type { RouteCapacityModel } from 'pos-shared/models/routeSchema.ts';

interface RouteCapacityProps {
  form: UseFormReturn<RouteCapacityModel>;
  route?: RouteModel;
}

const CapacityTabContent = ({ form }: RouteCapacityProps) => {
  const { t } = useTranslation();

  const { jobTypes, isLoadingJobTypes } = useServiceJobTypes();

  const capabilitiesList = [
    ...new Map(
      jobTypes?.map((v) => [v.name, { value: v.name, label: v.name }])
    ).values(),
  ];

  return (
    <Form
      fields={createFormFields(form)}
      layout="vertical"
      requiredMark={false}
    >
      <Row>
        <Col span={24}>
          <PosSelect
            label={t('locations.capabilities')}
            control={form.control}
            name="capabilities"
            options={capabilitiesList}
            loading={isLoadingJobTypes}
            mode="multiple"
            filterSort={(optionA, optionB) =>
              sortStrings(optionA, optionB, 'label')
            }
          />
        </Col>
      </Row>

      <Row>
        <Col span={11}>
          <PosInputNumber
            control={form.control}
            name="capacitySettings.measure1"
            label={t('scheduling.capacityMeasures.measure1')}
            style={{ width: '100%' }}
          />
        </Col>
        <Col flex={'auto'} />
        <Col span={11}>
          <PosInputNumber
            control={form.control}
            name="capacitySettings.measure2"
            label={t('scheduling.capacityMeasures.measure2')}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>

      <Row>
        <Col span={11}>
          <PosInputNumber
            control={form.control}
            label={t('scheduling.capacityMeasures.measure3')}
            name="capacitySettings.measure3"
            style={{ width: '100%' }}
          />
        </Col>
        <Col flex={'auto'} />
        <Col span={11}>
          <PosInputNumber
            control={form.control}
            name="capacitySettings.measure4"
            label={t('scheduling.capacityMeasures.measure4')}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default CapacityTabContent;
